import React from "react";
import { Link as RouterLink } from "react-router-dom";

const geist = { fontFamily: "'Geist', sans-serif" };
const instrumentSerif = { fontFamily: "'Instrument Serif', Georgia, serif" };
const geistMono = { fontFamily: "'Geist Mono', monospace" };

const CheckIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    style={{ flexShrink: 0, marginTop: "1px" }}
  >
    <circle cx="10" cy="10" r="10" fill="#295B4A" />
    <path
      d="m6 10.2 2.5 2.4L14 7.2"
      stroke="#FFFFFF"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CARDS = [
  {
    title: "Business types that qualify",
    items: [
      "Registered businesses (CAC / Business name)",
      "Traders, retailers & wholesalers",
      "Manufacturers & light industry",
      "Service providers & logistics operators",
    ],
  },
  {
    title: "Required Documents",
    items: [
      "Valid ID & BVN of the owner/director",
      "CAC registration documents",
      "Proof of business address",
      "Recent business activity statement",
    ],
  },
];

const EligibilityCard = ({ card }) => (
  <div
    style={{
      flex: "1 1 0",
      minWidth: 0,
      backgroundColor: "#F7F8F5",
      border: "1px solid #E6EAE2",
      borderRadius: "16px",
      padding: "clamp(24px, 2.2vw, 32px)",
      display: "flex",
      flexDirection: "column",
      gap: "20px",
      boxSizing: "border-box",
    }}
  >
    <h3
      style={{
        ...geist,
        fontWeight: 600,
        fontSize: "clamp(16px, 1.25vw, 18px)",
        lineHeight: 1.3,
        color: "#132A22",
        margin: 0,
      }}
    >
      {card.title}
    </h3>

    <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
      {card.items.map((item) => (
        <div
          key={item}
          style={{ display: "flex", alignItems: "flex-start", gap: "12px" }}
        >
          <CheckIcon />
          <span
            style={{
              ...geist,
              fontWeight: 400,
              fontSize: "clamp(13px, 1.04vw, 15px)",
              lineHeight: 1.5,
              color: "#3F5445",
            }}
          >
            {item}
          </span>
        </div>
      ))}
    </div>
  </div>
);

const Eligibility = () => {
  return (
    <>
      <style>{`
        .sme-elig-row {
          max-width: 1280px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: clamp(280px, 30vw, 380px) 1fr;
          column-gap: clamp(32px, 5vw, 80px);
          row-gap: 28px;
          align-items: start;
        }
        .sme-elig-intro { grid-column: 1; grid-row: 1; }
        .sme-elig-cards { grid-column: 2; grid-row: 1 / span 2; min-width: 0; display: flex; gap: clamp(16px, 1.67vw, 24px); }
        .sme-elig-cta { grid-column: 1; grid-row: 2; justify-self: start; align-self: start; }
        @media (max-width: 900px) {
          .sme-elig-row { grid-template-columns: 1fr; }
          .sme-elig-intro { grid-row: 1; }
          .sme-elig-cards { grid-column: 1; grid-row: 2; }
          .sme-elig-cta { grid-column: 1; grid-row: 3; }
        }
        @media (max-width: 600px) {
          .sme-elig-cards { flex-direction: column !important; }
        }
      `}</style>

      <section
        style={{
          width: "100%",
          backgroundColor: "transparent",
          boxSizing: "border-box",
          padding: "clamp(56px, 6.94vw, 100px) clamp(20px, 5.56vw, 80px)",
        }}
      >
        <div className="sme-elig-row">
          {/* Left intro */}
          <div
            className="sme-elig-intro"
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span
                style={{
                  width: "8px",
                  height: "8px",
                  borderRadius: "50%",
                  backgroundColor: "#66A681",
                  flexShrink: 0,
                  display: "inline-block",
                }}
              />
              <span
                style={{
                  ...geistMono,
                  fontWeight: 500,
                  fontSize: "12px",
                  lineHeight: 1,
                  letterSpacing: "0.1em",
                  color: "#295B4A",
                  textTransform: "uppercase",
                }}
              >
                Eligibility
              </span>
            </div>

            <h2
              style={{
                ...instrumentSerif,
                fontWeight: 400,
                fontSize: "clamp(30px, 3.61vw, 52px)",
                lineHeight: 1.08,
                letterSpacing: "-0.01em",
                color: "#132A22",
                margin: 0,
              }}
            >
              Who can Apply
            </h2>

            <p
              style={{
                ...geist,
                fontWeight: 400,
                fontSize: "clamp(14px, 1.11vw, 16px)",
                lineHeight: 1.65,
                color: "#5A6B60",
                margin: 0,
              }}
            >
              Simple requirements for businesses looking to bank or grow with
              Zikora.
            </p>
          </div>

          {/* Right cards */}
          <div className="sme-elig-cards">
            {CARDS.map((card) => (
              <EligibilityCard key={card.title} card={card} />
            ))}
          </div>

          {/* CTA — under the intro on desktop, below the cards on mobile */}
          <RouterLink
            className="sme-elig-cta"
            to="/contact"
            style={{
              ...geist,
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              height: "48px",
              padding: "0 22px",
              backgroundColor: "transparent",
              border: "1px solid #C9D3CC",
              borderRadius: "8px",
              fontWeight: 600,
              fontSize: "clamp(13px, 1.04vw, 15px)",
              color: "#132A22",
              textDecoration: "none",
            }}
          >
            Not sure? Ask an Advisor
          </RouterLink>
        </div>
      </section>
    </>
  );
};

export default Eligibility;
